export default __webpack_public_path__ + "static/media/cinema-sample.2b56e92c.png";